import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "hotelCancellationTransformer",
  standalone: true
})
export class HotelCancellationTransformerPipe implements PipeTransform {

  transform(cancellation: any[]): boolean {
    if (cancellation) {
      return !!cancellation.filter(i => i.type === "refundable").length;
    }
    return false;
  }

}
